import { observer } from 'mobx-react-lite'
import { type FC, useRef, useEffect } from 'react'
import { useLocation } from 'react-router'
import classNames from 'classnames'
import { Button, Typography } from 'shared/ui'
import { type CannedMessage } from 'entities/CannedMessages/model/CannedMessage'
import { IconSharedSavedReply } from 'entities/CannedMessages'
import { SavedRepliesActions } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/SavedRepliesListContent/SavedRepliesActions/SavedRepliesActions'
import { useSavedRepliesContext } from 'pages/settings/pages/savedReplies/context/savedRepliesContext'
import { SavedRepliesPath } from 'pages/settings/pages/savedReplies/route/savedRepliesPath'

import styles from './styles.module.scss'

type ISavedReplyItemProps = {
  item: CannedMessage
}

export const SavedReplyItem: FC<ISavedReplyItemProps> = observer(({ item }) => {
  const store = useSavedRepliesContext()
  const { selectedSavedReply, setSelectedSavedReplyRef, handleSelectSavedReply } = store
  const ref = useRef<HTMLButtonElement>(null)

  const location = useLocation()

  const handleSelect = () =>
    handleSelectSavedReply(item, location.pathname !== SavedRepliesPath.root)

  const onClick = () => {
    handleSelect()
  }

  useEffect(() => {
    if (selectedSavedReply?.id === item.id) {
      setSelectedSavedReplyRef(ref)
    }
  }, [selectedSavedReply])

  return (
    <Button
      ref={ref}
      typeBtn={'inbox'}
      onClick={onClick}
      className={classNames(styles.button, {
        [styles.active]: selectedSavedReply?.id === item.id,
      })}
      paddingInline={'12px 8px'}
      titleContent={
        <div className={styles.wrap}>
          <Typography variant={'body-md-regular'} ellipsis ariaLabel={'title'}>
            {item.title}
          </Typography>
          <div className={styles.actions}>
            <IconSharedSavedReply
              savedReply={item}
              className={styles.titleIcon}
              iconProps={{ fontSize: 12 }}
            />
            <SavedRepliesActions
              variantTriggerButton={'icon'}
              savedReply={item}
              tooltipParentElement={store.leftContentElement}
              collapsed
            />
          </div>
        </div>
      }
      active={selectedSavedReply?.id === item.id}
    />
  )
})
